import React, { Component } from 'react'
import { Link } from 'react-router-dom'
// components
import SignUpSuccess from './SignUpSuccess/SignUpSuccess'
import { trackTimeSpent } from '../../utils/Analytics'
// css
import './TeacherOnBoardSuccess.css'

class TeacherOnBoardSuccess extends Component {
  constructor (props) {
    super(props)
    this.state = {
      signupform: true
    }
  }

  componentDidMount () {  
    this.startTime = Date.now();
    this.currentPath = window.location.href;
  }

  componentWillUnmount() {
      trackTimeSpent('/teacheronboardsuccess', this.currentPath, this.startTime);
  }

  render () {
    return (
      <div id='teacher-on-board-success'>
        <div id='outer-blk'>
          <div className='logo-blk'>
            <Link to='/'>
              <img src={process.env.PUBLIC_URL + '/assets/images/logo.svg'} className='logo-img' alt='logo' />
            </Link>
            <div className='vr-line' />
            <Link to='/'>
              <img src={process.env.PUBLIC_URL + '/assets/images/ic_everforward.png'} className='ever-img' alt='logo' />
            </Link>
          </div>
          <div id='right-side-blk'>
            <SignUpSuccess />
          </div>
        </div>
      </div>
    )
  }
}

export default TeacherOnBoardSuccess
